export default __webpack_public_path__ + "static/media/preview-pro.08c64de6.gif";